import classNames from 'classnames';
import { range } from 'lodash-es';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';

const TradingButtonSkeleton: FC = () => (
  <div className="mx-3 mb-3">
    <div className="mb-3"></div>
    <div className="d-flex flex-column">
      <button disabled className="btn btn-xl m-1 btn-secondary">
        <Skeleton width="0em" />
      </button>
      <div className="d-flex">
        <button disabled className="btn btn-xl flex-grow-1 m-1 btn-secondary">
          <Skeleton width="0em" />
        </button>
        <button disabled className="btn btn-xl flex-grow-1 m-1 btn-secondary">
          <Skeleton width="0em" />
        </button>
      </div>
    </div>
  </div>
);

const ShareButtonSkeleton: FC = () => (
  <div className="position-absolute" style={{ right: 8, top: 8 }}>
    <button type="button" disabled className="btn btn-sm btn-icon-start p-2 btn-flat-warning">
      <Skeleton width="4em" />
      <i className="icon btn-sm me-0 ms-2 px-0">
        <Skeleton width="1em" />
      </i>
    </button>
  </div>
);

const MainTabContentSkeleton: FC = () => {
  return (
    <div className="h-100 d-flex flex-column">
      <ul className="list-group list-group-flush mt-3 overflow-y-auto" data-e2e="quote-details">
        {range(0, 10).map((index: number) => (
          <li
            key={index}
            className="list-group-item border-bottom d-md-flex justify-content-md-between ps-0 pe-3"
            data-e2e="QuoteExternalId"
          >
            <span className="text-secondary">
              <Skeleton width="10em" />
            </span>
            <div className="text-truncate">
              <span className="fw-bold" data-e2e="ExternalQuoteId-value">
                <Skeleton width="4em" />
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

const QuoteStatusSkeleton: FC = () => (
  <div id="side-panel-status">
    <div className="w-100 alert alert-discreet-primary d-flex mb-0 text-secondary">
      <div className="d-flex flex-column">
        <ShareButtonSkeleton />
        <div className="display-5 align-middle">
          <Skeleton width="6em" />
        </div>
        <div className="display-3 tabular-figures">
          <Skeleton width="4em" />
          <span className="h1 ps-2">
            <Skeleton width="1em" />
          </span>
        </div>
        <div className="align-middle text-large">
          <Skeleton width="15em" />
        </div>
        <div className="align-middle fw-bold fs-6 mt-3 position-absolute" style={{ right: '16px', bottom: '8px' }}>
          <Skeleton width="20em" />
        </div>
      </div>
    </div>
  </div>
);

const TopTabsSkeleton: FC<{ sizes: number[]; activeIndex: number }> = ({ sizes, activeIndex }) => (
  <ul className="nav m-2 my-3">
    {sizes.map((size, index) => (
      <li key={index}>
        <a className={classNames('nav-link px-2', { active: activeIndex === index })}>
          <h5>
            <Skeleton width={`${size}em`} />
          </h5>
        </a>
      </li>
    ))}
  </ul>
);

export const SidePanelSkeleton: FC = () => {
  return (
    <div className="card bg-lvl1 border-start d-flex flex-column h-100 position-relative overflow-y-auto">
      <TopTabsSkeleton sizes={[5, 7, 10]} activeIndex={1} />
      <QuoteStatusSkeleton />
      <div className="card-body flex-grow-1 flex-shrink-1">
        <MainTabContentSkeleton />
      </div>
      <TradingButtonSkeleton />
    </div>
  );
};
